import StampYouRock from "../images/customisation-assets/YouRock_Stamp.png";
import StampYouMe from "../images/customisation-assets/YouMe_Stamp.png";
import StampLove from "../images/customisation-assets/Love_Stamp.png";
import StampRockstar from "../images/customisation-assets/Rockstar_Stamp.png";
import StampCool from "../images/customisation-assets/Cool_Stamp.png";
import StampBusy from "../images/customisation-assets/Busy_Stamp.png";

// Selection option assets
import OptionYouRock from "../images/customisation-option-icons/YouRock_Option.png";
import OptionYouMe from "../images/customisation-option-icons/YouMe_Option.png";
import OptionLove from "../images/customisation-option-icons/Love_Option.png";
import OptionRockstar from "../images/customisation-option-icons/Rockstar_Option.png";
import OptionCool from "../images/customisation-option-icons/Cool_Option.png";
import OptionBusy from "../images/customisation-option-icons/Busy_Option.png";
import OptionNone from "../images/customisation-option-icons/None_Option.svg";

// Thumbnails
import StampYouRockThumb from "../images/customisation-asset-thumbnails/YouRock_Stamp_50x50.png";
import StampYouMeThumb from "../images/customisation-asset-thumbnails/YouMe_Stamp_50x50.png";
import StampLoveThumb from "../images/customisation-asset-thumbnails/Love_Stamp_50x50.png";
import StampRockstarThumb from "../images/customisation-asset-thumbnails/Rockstar_Stamp_50x50.png";
import StampCoolThumb from "../images/customisation-asset-thumbnails/Cool_Stamp_50x50.png";
import StampBusyThumb from "../images/customisation-asset-thumbnails/Busy_Stamp_50x50.png";
import StampNoneThumb from "../images/customisation-asset-thumbnails/None_Stamp_50x50.png";

export const STAMP_OPTIONS = {
  youRock: {
    title: "You Rock",
    watchLayerAsset: StampYouRock,
    watchLayerThumbnail: StampYouRockThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionYouRock,
    },
  },
  youMe: {
    title: "You Me",
    watchLayerAsset: StampYouMe,
    watchLayerThumbnail: StampYouMeThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionYouMe,
    },
  },
  love: {
    title: "Love",
    watchLayerAsset: StampLove,
    watchLayerThumbnail: StampLoveThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionLove,
    },
  },
  cool: {
    title: "You Are Cool",
    watchLayerAsset: StampCool,
    watchLayerThumbnail: StampCoolThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionCool,
    },
  },
  rockstar: {
    title: "Rockstar",
    watchLayerAsset: StampRockstar,
    watchLayerThumbnail: StampRockstarThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionRockstar,
    },
  },
  busy: {
    title: "Busy",
    watchLayerAsset: StampBusy,
    watchLayerThumbnail: StampBusyThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionBusy,
    },
  },
  none: {
    title: "None",
    watchLayerThumbnail: StampNoneThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionNone,
    },
  },
};
